module.exports = __webpack_public_path__ + "img/rubin_benefit_01_giftcard.0d3760ff.svg";